
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher";
import { useAuth } from "@/contexts/AuthContext";

const LandingHeader = () => {
  const { t } = useTranslation('common');
  const { user, loading } = useAuth();

  const handleAuthAction = () => {
    if (user) {
      // Redirect authenticated users to app
      window.location.href = 'https://app.uplivion.life/dashboard';
    } else {
      // Redirect non-authenticated users to login
      window.location.href = 'https://app.uplivion.life/login';
    }
  };

  return (
    <header className="fixed top-0 w-full z-50 backdrop-blur-md bg-white/70 border-b border-white/20">
      <div className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <img 
            src="/uplivion-logo.svg" 
            alt="uplivion" 
            className="h-8 w-auto"
          />
          <div className="flex items-center gap-2">
            <LanguageSwitcher />
            {loading ? (
              <div className="w-20 h-10 bg-gray-200 animate-pulse rounded"></div>
            ) : (
              <Button 
                onClick={handleAuthAction}
                variant="ghost" 
                className="text-uplivion-blue hover:bg-uplivion-blue/10 font-medium"
              >
                {user ? 'Zur App' : t('buttons.login')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default LandingHeader;
